import { useQuery } from "@tanstack/react-query";

import stellar from "@/services/stellar";
import type { ConfigItem } from "../types";

export const CONFIGS_QUERY_KEY = ["configs"] as const;

const fetchConfigs = async () => {
  const { configs } = (await stellar.action("getConfigs")) as {
    configs: ConfigItem[];
  };

  return configs;
};

export const useConfigsQuery = () =>
  useQuery({
    queryKey: CONFIGS_QUERY_KEY,
    queryFn: fetchConfigs,
  });
